import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { AreaInsertService } from '../../service/area-insert/area-insert.service';

@Component({
	selector: 'app-area-insert',
	templateUrl: './area-insert.component.html',
	providers: [
		AreaInsertService,
		HttpModule
	]
})
export class AreaInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	area: FormGroup;
	Nome: string = "";
	statusArea: boolean;

	constructor(fb: FormBuilder, private areaInsertService: AreaInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.area = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addArea(value: any) {
		console.log(value);
		this.areaInsertService.insertArea(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Área Irrigada cadastrada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/area');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/area');
	}

}


// WEBPACK FOOTER //
// ./src/app/area/component/area-insert/area-insert.component.ts